module.exports = __webpack_public_path__ + "media/images/landkit/screenshots/landkit/pages/contact-9aa43a4a298abe2c237601930f11e97e.jpg";